module.exports = __webpack_public_path__ + "img/gzhm_logo.c4a0806a.png";